import { addClass, removeClass } from '../../common/Utils';
import { popupClass } from '../constants/class';
import { iOSfix, undoIOSfix } from '../util/iosFix';
import {
    ModalOption,
    ModalPromiseResult,
    ModalPromiseResolve,
} from '../../interface/IModal';
import AbstractNotification from './AbstractNotification';
import { handleState } from '../constants/state';

export default class Modal extends AbstractNotification {
    constructor() {
        super();
    }
    protected initModal(): void {
        super.initModal();
        if (document.querySelectorAll(`#${popupClass.POPUP}`).length <= 0)
            removeClass(document.body, popupClass.POPUP_SHOW);
    }
    protected close(): void {
        undoIOSfix();
        super.close();
    }
    async open(options: ModalOption): Promise<ModalPromiseResult> {
        super.open(options);
        this.addClassForPopup();
        this.addClassForPopupAnimation();
        iOSfix(this.$backdrop);
        setTimeout(() => {
            this.$backdrop.scrollTop = 0;
        });

        return await new Promise((resolve) => {
            this.addEventsByOptionsInPopup(resolve);
            super.focusOnButton();
            super.setTimerOption(resolve);
        });
    }
    private addClassForPopup() {
        this.$backdrop.id = popupClass.POPUP;
        addClass(document.body, popupClass.POPUP_SHOW);
    }
    private addClassForPopupAnimation(): void {
        !!this.options.showClass
            ? addClass(this.$backdrop, this.options.showClass)
            : addClass(this.$modalContent, popupClass.POPUP_CONTAINER_SHOW);
    }
    private addEventsByOptionsInPopup(resolve: ModalPromiseResolve) {
        super.addEventsByOptions(resolve);
        this.addKeyboardEvent();
        this.addEscapeKeyListener(resolve);
        this.addBackdropClickListener(resolve);
    }
    // button만 탭으로 focus 되되록
    private addKeyboardEvent(): void {
        this.$backdrop.addEventListener('keydown', (e) => {
            e.stopPropagation();
            if (e.key === 'Tab') {
                if (e.target === this.$cancelButton) {
                    this.$confirmButton?.focus();
                    e.preventDefault();
                } else if (e.target === this.$confirmButton) {
                    this.$cancelButton?.focus();
                    e.preventDefault();
                }
            }
        });
    }
    private addEscapeKeyListener(resolve: ModalPromiseResolve): void {
        if (this.options.allowEscapeKey) {
            this.$modalContent.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    e.preventDefault();
                    super.close();
                    resolve({
                        value: handleState.ESC,
                        isConfirmed: false,
                        isCancel: false,
                    });
                }
            });
        }
    }
    private addBackdropClickListener(resolve: ModalPromiseResolve): void {
        if (this.options.allowOutsideClick) {
            this.$backdrop.addEventListener('click', (e: MouseEvent) => {
                if (e.currentTarget !== e.target) return;
                e.stopPropagation();
                super.close();
                resolve({
                    value: handleState.BACKDROP,
                    isConfirmed: false,
                    isCancel: false,
                });
            });
        }
    }
}
